import styled from "styled-components"
import styleConstants from "../../constants/styleConstants"

export const Container = styled.div`
  width: 100%;
  height: 100vh; /*fallback*/
  height: calc((var(--realVh, 1vh) * 100));
  background-color: ${styleConstants.blue00};
`
